module["exports"] = [
  "#{Address.state} #{creature}"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/es_MX/team/name.js
// module id = 1148
// module chunks = 0